import {
    Drawer,
    Input,
    Col,
    Select,
    Form,
    Button,
    Row,
    Spin
} from 'antd';
import { LoadingOutlined } from "@ant-design/icons";
import { useLayoutEffect, useState } from 'react';
import { createProducts, updateCustomer } from '@/apiCalls/apiCalls';
import { errorNotification, successNotification } from '@/utils/Notification';
import { Customers } from './CustomersColumns';
import { useLocation, useNavigate } from 'react-router-dom';
import useAxiosPrivate from '@/context/UseAxiosPrivate';


const { Option } = Select;

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />
interface CustomerDrawerProps {
    showUpdateCustomerDrawer: boolean;
    setShowUpdateCustomerDrawer: React.Dispatch<React.SetStateAction<boolean>>;
    customers: Customers
    getCustomers: any
    setCustomerData: React.Dispatch<React.SetStateAction<Customers | undefined>>;
}
const UpdateCustomerDrawer: React.FC<CustomerDrawerProps> = ({ showUpdateCustomerDrawer, setShowUpdateCustomerDrawer, customers, getCustomers, setCustomerData }) => {
    const onCLose = () => {
        setShowUpdateCustomerDrawer(false)
        setCustomerData(undefined)
    }
    const [submitting, setSubmitting] = useState(false)
    const [form] = Form.useForm()
    const navigate = useNavigate()
    const location = useLocation()
    const axiosPrivate = useAxiosPrivate()

    const onFinish = (customers: any) => {
        setSubmitting(true)
        let isMounted = true;
        const controller = new AbortController()
        axiosPrivate.put(`/api/v1/customers/${customers.id}`, customers, {
            signal: controller.signal
        }).then(() => {
            if (isMounted) {
                onCLose()
                successNotification(
                    "Customers successfully updated",
                    `${customers.name} was updated`,
                    'topRight'
                )
            }
            getCustomers()
        }).catch((err: any) => {
            const errors = err?.response?.data?.errors;
            if (errors && errors?.[0]?.message === "token as expired") {
                let errror = errors?.[0]?.message
                errorNotification(
                    "There was an issue",
                    `${errror}`,
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            } else if (errors && Array.isArray(errors) && errors.length > 0) {
                errors.forEach((error: any) => {
                    const errorMessage = error.message || "An unknown error occurred";
                    errorNotification(
                        "There was an issue",
                        `${errorMessage}`,
                        'topRight'
                    );
                });
            } else {
                errorNotification(
                    "There was an issue",
                    "No server reponse",
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            }
        }).finally(() => {
            setSubmitting(false)
        })
        return () => {
            isMounted = false;
            controller.abort();
        };
    };

    const onFinishFailed = (errorInfo: any) => {
        alert(JSON.stringify(errorInfo, null, 2));
    }

    useLayoutEffect(() => {
        const setFormValues = async () => {

            form.setFieldsValue(customers)
        };
        if (customers) {
            setFormValues()
        }
    }, [customers, form])

    return <Drawer
        title="Update Customers"
        width={720}
        onClose={onCLose}
        open={showUpdateCustomerDrawer}
        bodyStyle={{ paddingBottom: 80 }}
        style={{ backgroundColor: 'white' }}
        footer={
            <div
                style={{
                    textAlign: 'right',
                }}
            >
                <Button onClick={onCLose} style={{ marginRight: 8 }}>
                    Cancel
                </Button>
            </div>
        }
    >
        <Form layout="vertical"
            onFinishFailed={onFinishFailed}
            onFinish={onFinish}
            initialValues={customers}
            form={form}
            requiredMark={false}>
            <Row gutter={16}>
                <Col span={12}>
                    <Form.Item
                        name="name"
                        label="name"
                        rules={[{ required: true, message: 'Please enter name' }]}
                    >
                        <Input
                            placeholder="Please enter name"
                            className='focus:border-green-500 hover:border-green-500'
                        />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        name="description"
                        label="Description"
                        rules={[{ required: true, message: 'Please enter description ' }]}
                    >
                        <Input
                            placeholder="Please enter description"
                            className='focus:border-green-500 hover:border-green-500'
                        />
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={16}>
                <Col span={12}>
                    <Form.Item
                        name="id"
                        label="id"
                        hidden={true}
                        rules={[{ required: true, message: 'Please enter loan id' }]}
                    >
                        <Input placeholder="Please enter loan id" className='focus:border-green-500 hover:border-green-500' />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        name="status"
                        label="status"
                        hidden={true}
                        rules={[{ required: true, message: 'Please enter loan id' }]}
                    >
                        <Input placeholder="Please enter loan id" className='focus:border-green-500 hover:border-green-500' />
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col span={12}>
                    <Form.Item>
                        <Button type="primary" htmlType="submit" style={{ backgroundColor: 'green' }}>
                            Submit
                        </Button>
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                {submitting && <Spin indicator={antIcon} />}
            </Row>
        </Form>
    </Drawer>
}

export default UpdateCustomerDrawer;


